import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: "zys-jingshui-state",
  storage: window.localStorage,
  reducer: state => ({
    deviceSession: state.deviceSession
  })
});

const vuexSession = new VuexPersistence({
  key: "zys-jingshui-auth",
  storage: window.sessionStorage,
  reducer: state => ({
    accessToken: state.accessToken
  })
});

function emptyDeviceSession() {
  return {
    username: "",
    password: "",
    serialNumber: ""
  };
}

export default new Vuex.Store({
  state: {
    deviceSession: emptyDeviceSession(),
    accessToken: ""
  },
  getters: {
    deviceSession: state => state.deviceSession,
    accessToken: state => state.accessToken,
    isDeviceAuthenticated: state =>
      [
        state.deviceSession.username,
        state.deviceSession.password,
        state.deviceSession.serialNumber
      ].every(value => typeof value === "string" && value.trim())
  },
  mutations: {
    setDeviceSession(state, session) {
      state.deviceSession = {
        username: session.username,
        password: session.password,
        serialNumber: session.serialNumber
      };
    },
    clearDeviceSession(state) {
      state.deviceSession = emptyDeviceSession();
    },
    setVisualizationAccessToken(state, accessToken) {
      state.accessToken =
        typeof accessToken === "string"
          ? accessToken.replace(/^WLXS\s+/i, "").trim()
          : "";
    },
    clearVisualizationAccessToken(state) {
      state.accessToken = "";
    }
  },
  plugins: [vuexLocal.plugin, vuexSession.plugin]
});
